import { HandlingMode } from '~/shared';
import { createSlice } from '../wrappers';

const initialState = {
	mode: HandlingMode.Comfort,
	modalVisible: false,
	modalSaveModel: '',
	modalSaveMode: '',
	unsavedChanges: false,
	activeTab: 0,
	initialHandling: {} as Record<string, any>,
};

const handlingSlice = createSlice({
	name: 'handling',
	initialState,
	reducers: {
		showSaveModal: (state) => {
			state.modalVisible = true;
		},
		hideModal: (state) => {
			state.modalVisible = false;
		},
		setModalSaveParams: (state, action) => {
			state.modalSaveModel = action.payload.model;
			state.modalSaveMode = action.payload.mode;
		},
		setModeValue: (state, action) => {
			state.mode = action.payload;
		},
		setUnsavedChanges: (state, action) => {
			state.unsavedChanges = action.payload;
		},
		setActiveTab: (state, action) => {
			if (state.modalVisible) {
				return;
			}

			state.activeTab = action.payload;
		},
		setInitialHandling: (state, action) => {
			state.initialHandling = action.payload;
		},
	},
});

export const {
	showSaveModal,
	hideModal,
	setModeValue,
	setUnsavedChanges,
	setActiveTab,
	setInitialHandling,
} = handlingSlice.actions;

export default handlingSlice.reducer;
